import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { StoreProvider } from "@/context/StoreContext";
import Home from "@/pages/Home";
import Commander from "@/pages/Commander";
import Checkout from "@/pages/Checkout";
import MesCommandes from "@/pages/MesCommandes";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App">
      <StoreProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/commander" element={<Commander />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/mes-commandes" element={<MesCommandes />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </StoreProvider>
    </div>
  );
}

export default App;
